import React from 'react';

import { Typography } from '@occc-app/design-system';
import { awardHelper } from '@occc-app/offerHelpers/utils/awardHelper';
import { AwardFragment } from '@occc-app/offerHelpers/types';

import { PointsAward } from './PointsAward';
import { PointsPerAward } from './PointsPerAward';
import { VouchersAward } from './VouchersAward';
import { ExternalPoints } from './ExternalPoints';
import { TransactionMoneyDiscountAward } from './TransactionMoneyDiscountAward';
import { TransactionPercentDiscountAward } from './TransactionPercentDiscountAward';
import { MoneyDiscountAward } from './MoneyDiscountAward';
import { PriceOverrideAward } from './PriceOverrideAward';
import { BuyAndGetAward } from './BuyAndGetAward';
import { ProductDiscountAward } from './ProductDiscountAward';

interface IAwardProps {
  award: AwardFragment;
}

export const Award: React.FC<IAwardProps> = ({ award }) => {
  if (awardHelper.isPointsAward(award)) {
    return <PointsAward award={award} />;
  }
  if (awardHelper.isPointsPerAward(award)) {
    return <PointsPerAward award={award} />;
  }
  if (awardHelper.isVouchersAward(award)) {
    return <VouchersAward award={award} />;
  }
  if (awardHelper.isExternalPointsAward(award)) {
    return <ExternalPoints award={award} />;
  }
  if (awardHelper.isTransactionMoneyDiscountAward(award)) {
    return <TransactionMoneyDiscountAward award={award} />;
  }
  if (awardHelper.isTransactionPercentDiscountAward(award)) {
    return <TransactionPercentDiscountAward award={award} />;
  }
  if (awardHelper.isMoneyDiscountAward(award)) {
    return <MoneyDiscountAward award={award} />;
  }
  if (awardHelper.isPriceOverrideAward(award)) {
    return <PriceOverrideAward award={award} />;
  }
  if (awardHelper.isBuyAndGetAward(award)) {
    return <BuyAndGetAward award={award} />;
  }
  if (awardHelper.isProductDiscountAward(award)) {
    return <ProductDiscountAward award={award} />;
  }

  return <Typography color='error'>Something went wrong.</Typography>;
};
